import { HeaderSearch } from './header-search';
import { HeaderSearchMobile } from './header-search-mobile';
import { HeaderShadow } from './header-shadow';

export class Header {

    public constructor() {
        this.init();
    }

    private init() : void {
        new HeaderSearch();
        new HeaderSearchMobile();
        new HeaderShadow();
    }

}
